import React from 'react';

interface FollowUpNoteProps {
    note: string;
}

export const FollowUpNote: React.FC<FollowUpNoteProps> = ({ note }) => (
    <p data-testid="followup-note" className="self-start rounded-sm bg-surface-note-highlight text-body font-normal text-content">
        {note}
    </p>
);
